import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useSuperDuper } from '../context/SuperDuperContext';
import { renderLoading, renderError } from '../components/StatusViews';
import SubscriptionFilters from './subscriptions/SubscriptionFilters';
import SubscriptionsTable from './subscriptions/SubscriptionsTable';

const SubscriptionsTab = () => {
  const {
    subscriptions,
    loading,
    error,
    subscriptionSubTab,
    filterSubscriptionsByAge,
    filterSubscriptionsBySearch
  } = useSuperDuper();

  // The "Current Subscribers" sub tab is the only one that also applies the age filter
  const visibleSubscriptions = filterSubscriptionsBySearch(
    subscriptionSubTab === 1 ? filterSubscriptionsByAge(subscriptions) : subscriptions
  );

  return (
    <>
      <Typography
        variant="h4"
        sx={{ mb: { xs: 2, sm: 3 }, fontSize: { xs: '1.35rem', sm: '2.125rem' } }}
      >
        Subscription Analytics
      </Typography>

      <SubscriptionFilters />

      <Box sx={{ mb: { xs: 2, sm: 4 } }}>
        <Paper sx={{ p: { xs: 2, sm: 3 } }}>
          <Typography variant="h6" gutterBottom>
            Summary
          </Typography>
          <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Total Impressions
              </Typography>
              <Typography variant="h4" sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
                {visibleSubscriptions.length}
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>

      {loading ? (
        renderLoading()
      ) : error ? (
        renderError(error)
      ) : (
        <SubscriptionsTable rows={visibleSubscriptions} />
      )}
    </>
  );
};

export default SubscriptionsTab;
